import { render } from "./OcrMappingStepper.vue?vue&type=template&id=7ba16e74"
import script from "./OcrMappingStepper.vue?vue&type=script&lang=js"
export * from "./OcrMappingStepper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__